import utils from './util.js';
import isMobile from 'is-mobile';

window.onscroll = utils.throttle(scrollResolve, 200);

let scrollTopBtn = document.querySelector('.scroll-top');

function scrollResolve() {
  let scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  if (scrollTop > 50) {
    scrollTopBtn.classList.add('scale-in');
  } else {
    scrollTopBtn.classList.remove('scale-in');
  }
}

scrollTopBtn.onclick = function () {
  if (!scrollTopBtn.animating) {
    scrollTopBtn.animating = true;
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    scrollTopBtn.animating = false;
  }
};

// Mobile menu
let mobileBtn = document.querySelector('.header-toggle-btn');

const menuBtnHandle = (e) => {
  let cur = e.currentTarget;
  if (!cur.isMenuOpen) {
    document.documentElement.classList.add('mobile-menu-open');
    cur.classList.add('active');
  } else {
    document.documentElement.classList.remove('mobile-menu-open');
    cur.classList.remove('active');
  }
  cur.isMenuOpen = !cur.isMenuOpen;
};

utils.addEvent(mobileBtn, 'click', menuBtnHandle);

// Desktop dropdown menu
function initDesktopSubMenu() {
  const allMenuItems = Array.from(document.querySelectorAll('.menu .menu-item'));
  const menuItems = allMenuItems.filter((item) => item.querySelector('.sub-menu'));

  if (menuItems.length === 0) return;

  const body = document.body;
  const menuWrap = document.querySelector('.menu-wrap');
  const panel = document.querySelector('.header-panel');
  const enterEvent = window.PointerEvent ? 'pointerenter' : 'mouseenter';
  const leaveEvent = window.PointerEvent ? 'pointerleave' : 'mouseleave';
  const overEvent = window.PointerEvent ? 'pointerover' : 'mouseover';
  const downEvent = window.PointerEvent ? 'pointerdown' : 'mousedown';
  const openDelay = 120;
  const closeDelay = 180;

  if (!menuWrap || !panel) return;

  let activeItem = null;
  let openTimer = null;
  let closeTimer = null;
  const submenuMap = new WeakMap();
  const triggerMap = new WeakMap();

  const clearTimers = () => {
    if (openTimer) {
      clearTimeout(openTimer);
      openTimer = null;
    }
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  };

  const isWithinNav = (target) => {
    if (!target) return false;
    return menuWrap.contains(target) || panel.contains(target);
  };

  const getFirstFocusable = (submenu) =>
    submenu?.querySelector('a, button, [tabindex]:not([tabindex="-1"])');

  const syncPanelHeight = (submenu) => {
    const inner = submenu?.querySelector('.sub-menu-inner');
    const nextHeight = inner ? Math.ceil(inner.getBoundingClientRect().height) : 0;
    panel.style.height = `${nextHeight}px`;
  };

  const setItemState = (item, expanded) => {
    const trigger = triggerMap.get(item);
    const submenu = submenuMap.get(item);

    item.classList.toggle('is-open', expanded);
    trigger?.setAttribute('aria-expanded', String(expanded));
    submenu?.classList.toggle('is-active', expanded);
  };

  const closeActive = ({ restoreFocus = false } = {}) => {
    clearTimers();
    if (!activeItem) return;

    const previousItem = activeItem;
    const trigger = triggerMap.get(previousItem);

    setItemState(previousItem, false);
    activeItem = null;

    body.classList.remove('desktop-nav-open');
    panel.style.height = '0px';
    panel.setAttribute('aria-hidden', 'true');

    if (restoreFocus) {
      trigger?.focus();
    }
  };

  const openItem = (item, { focusFirst = false } = {}) => {
    clearTimers();

    const submenu = submenuMap.get(item);
    if (!submenu) return;

    if (activeItem && activeItem !== item) {
      setItemState(activeItem, false);
    }

    activeItem = item;
    setItemState(item, true);
    body.classList.add('desktop-nav-open');
    panel.setAttribute('aria-hidden', 'false');
    syncPanelHeight(submenu);

    if (focusFirst) {
      requestAnimationFrame(() => {
        getFirstFocusable(submenu)?.focus();
      });
    }
  };

  const scheduleClose = () => {
    clearTimers();
    closeTimer = setTimeout(() => closeActive(), closeDelay);
  };

  menuItems.forEach((item, index) => {
    const trigger = item.querySelector('.menu-text');
    const submenu = item.querySelector('.sub-menu');
    if (!trigger || !submenu) return;

    const menuId = item.dataset.menuId || `desktop-menu-${index + 1}`;
    const panelId = submenu.id || `${menuId}-panel`;

    item.dataset.menuId = menuId;
    submenu.id = panelId;
    submenu.setAttribute('aria-label', trigger.textContent?.trim() || 'submenu');
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-controls', panelId);
    trigger.setAttribute('aria-expanded', 'false');

    triggerMap.set(item, trigger);
    submenuMap.set(item, submenu);
    panel.appendChild(submenu);
  });

  allMenuItems.forEach((item) => {
    if (submenuMap.get(item)) return;

    item.addEventListener(enterEvent, (e) => {
      if (e.pointerType === 'touch') return;
      closeActive();
    });
  });

  menuItems.forEach((item) => {
    const trigger = triggerMap.get(item);
    const submenu = submenuMap.get(item);
    if (!trigger || !submenu) return;

    item.addEventListener(enterEvent, (e) => {
      if (e.pointerType === 'touch') return;
      clearTimers();
      openTimer = setTimeout(() => openItem(item), openDelay);
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (activeItem === item) {
        closeActive();
        return;
      }

      openItem(item);
    });

    trigger.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        openItem(item, { focusFirst: e.key === 'ArrowDown' });
      }

      if (e.key === 'Escape') {
        e.preventDefault();
        closeActive({ restoreFocus: true });
      }
    });

    item.addEventListener('focusin', () => {
      openItem(item);
    });

    item.addEventListener('focusout', (e) => {
      if (isWithinNav(e.relatedTarget)) return;
      scheduleClose();
    });
  });

  const handleRegionEnter = (e) => {
    if (e.pointerType === 'touch') return;
    clearTimers();
  };

  const handleRegionLeave = (e) => {
    if (e.pointerType === 'touch') return;
    if (isWithinNav(e.relatedTarget)) return;
    scheduleClose();
  };

  menuWrap.addEventListener(enterEvent, handleRegionEnter);
  menuWrap.addEventListener(leaveEvent, handleRegionLeave);
  panel.addEventListener(enterEvent, handleRegionEnter);
  panel.addEventListener(leaveEvent, handleRegionLeave);
  panel.addEventListener('focusin', clearTimers);
  panel.addEventListener('focusout', (e) => {
    if (isWithinNav(e.relatedTarget)) return;
    scheduleClose();
  });

  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      closeActive({ restoreFocus: true });
    }
  });

  document.addEventListener(downEvent, (e) => {
    if (!activeItem) return;
    if (isWithinNav(e.target)) return;
    closeActive();
  });

  document.addEventListener(overEvent, (e) => {
    if (!activeItem || e.pointerType === 'touch') return;

    if (isWithinNav(e.target)) {
      clearTimers();
      return;
    }

    scheduleClose();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeActive({ restoreFocus: true });
    }
  });

  window.addEventListener('resize', () => {
    if (!activeItem) return;
    syncPanelHeight(submenuMap.get(activeItem));
  });
}

// Mobile submenu accordion
function initMobileAccordion() {
  const entries = Array.from(document.querySelectorAll('.mobile-menu [data-toggle="submenu"]'))
    .map((toggle, index) => {
      const parent = toggle.closest('.mobile-menu-item');
      const submenu = parent?.querySelector('.mobile-sub-menu');

      if (!parent || !submenu) return null;

      const submenuId = submenu.id || `mobile-submenu-${index + 1}`;
      submenu.id = submenuId;

      toggle.setAttribute('role', 'button');
      toggle.setAttribute('tabindex', '0');
      toggle.setAttribute('aria-controls', submenuId);

      return { toggle, parent, submenu };
    })
    .filter(Boolean);

  if (entries.length === 0) return;

  const setExpanded = (entry, expanded) => {
    entry.parent.classList.toggle('is-active', expanded);
    entry.toggle.setAttribute('aria-expanded', String(expanded));
    entry.submenu.setAttribute('aria-hidden', String(!expanded));
  };

  entries.forEach((entry) => {
    setExpanded(entry, false);

    const toggleMenu = () => {
      const willExpand = !entry.parent.classList.contains('is-active');

      entries.forEach((currentEntry) => {
        setExpanded(currentEntry, currentEntry === entry ? willExpand : false);
      });
    };

    entry.toggle.addEventListener('click', toggleMenu);
    entry.toggle.addEventListener('keydown', (e) => {
      if (e.key !== 'Enter' && e.key !== ' ') return;

      e.preventDefault();
      toggleMenu();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      initDesktopSubMenu();
      initMobileAccordion();
    },
    false
  );
} else {
  initDesktopSubMenu();
  initMobileAccordion();
}

// Mobile menu overlay click to close
const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
if (mobileMenuOverlay && mobileBtn) {
  mobileMenuOverlay.addEventListener('click', function () {
    if (mobileBtn.isMenuOpen) {
      mobileBtn.click();
    }
  });
}

// ESC to close mobile menu
document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape' && mobileBtn && mobileBtn.isMenuOpen) {
    mobileBtn.click();
  }
});

// Close mobile menu after clicking a link
const mobileMenuLinks = document.querySelectorAll('.mobile-menu a');
mobileMenuLinks.forEach((link) => {
  link.addEventListener('click', function () {
    if (mobileBtn && mobileBtn.isMenuOpen) {
      setTimeout(() => {
        mobileBtn.click();
      }, 100);
    }
  });
});

const themeToggleBtn = document.querySelector('.theme-toggle');
const metaThemeColor = document.querySelector('meta[name="theme-color"]');

function changeMetaThemeColor() {
  let theme = document.documentElement.getAttribute('data-theme');
  if (theme === 'light') {
    metaThemeColor.setAttribute('content', '#FFFFFF');
  } else {
    metaThemeColor.setAttribute('content', '#f8ce5f');
  }
}

changeMetaThemeColor();

const handleChangeTheme = () => {
  const changeTheme = () => {
    let theme = document.documentElement.getAttribute('data-theme');
    if (theme === 'light') {
      localStorage.setItem('theme', 'dark');
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      localStorage.setItem('theme', 'light');
      document.documentElement.setAttribute('data-theme', 'light');
    }
    document.cookie = `theme=${localStorage.getItem(
      'theme'
    )};path=/;max-age=31536000`;

    changeMetaThemeColor();
  };

  if (!document.startViewTransition) {
    changeTheme();
    return;
  }

  document.startViewTransition(() => {
    changeTheme();
  });
};

if (isMobile()) {
  themeToggleBtn.addEventListener('touchstart', handleChangeTheme, {
    passive: true,
  });
} else {
  themeToggleBtn.addEventListener('click', handleChangeTheme, false);
}
